import type { EmailField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'
import React from 'react'

import { Error } from './Error'

export const Email: React.FC<
  EmailField & { errors: Partial<FieldErrorsImpl>; register: UseFormRegister<FieldValues> }
> = ({ name, defaultValue, errors, label, register, required }) => {
  return (
    <div className="field">
      <label htmlFor={name}>
        {label}
        {required && ' *'}
      </label>
      <input
        defaultValue={defaultValue}
        id={name}
        type="email"
        placeholder={label}
        {...register(name, { pattern: /^\S[^\s@]*@\S+$/, required })}
      />
      {errors[name] && <Error name={name} />}
    </div>
  )
}
